import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

function TopPage() {

  return (
    <div className="fixed bg-black bottom-[30px] right-[20px] z-[9999] w-[30px] h-[30px] text-center rounded-md">
      <a href="#top" className="text-white" aria-label="Ir para o topo">
        <ArrowUpwardIcon className="text-[35px] opacity-70" />
      </a>
    </div>
  );
}

export default TopPage;
